// PROFESSIONAL FOOTER – Aligned with Navbar Structure & Branding
import React from "react";
import { Link, NavLink } from "react-router-dom";
import { Facebook, Twitter, Instagram, Mail, Youtube } from "lucide-react";
import logo from "../Photos/Logotalkytoon.png"

const FOOTER_SECTIONS = [
  {
    title: "Learn",
    links: [
      { name: "Alphabet A–Z", path: "/alphabet" },
      { name: "Numbers & Math", path: "/numbers" },
      { name: "Reading & Phonics", path: "/phonics" },
      { name: "Science Basics", path: "/science" },
      { name: "Life Skills", path: "/lifeskills" },
    ],
  },
  {
    title: "Play",
    links: [
      { name: "Games", path: "/playgames" },
      { name: "Puzzle Corner", path: "/puzzlecorner" },
      { name: "Create & Draw", path: "/createdraw" },
      { name: "Animals & Sounds", path: "/animals" },
      { name: "Music & Dance", path: "/musicdance" },
    ],
  },
  {
    title: "Stories",
    links: [
      { name: "Story Time", path: "/storytime" },
      { name: "Moral Stories", path: "/moralstories" },
    ],
  },
  {
    title: "Parents",
    links: [
      { name: "Parent Dashboard", path: "/parentcontrol" },
      // { name: "Learning Tips", path: "/learningtips" },
      // { name: "Skill Development", path: "/skilldevelopment" },
    ],
  },
  {
    title: "Company",
    links: [
      { name: "Our Mission", path: "/mission" },
      // { name: "Careers", path: "/careers" },
      // { name: "Help Center", path: "/help" },
      { name: "Contact", path: "/contact" },
    ],
  },
];

export default function Footer() {
  // Use a slightly softer primary color for branding consistency
  const BRAND_COLOR = "text-teal-600";
  const HOVER_COLOR = "hover:text-teal-500";
  const ACCENT_BG = "bg-teal-50";

  return (
    // Change to a very light gray background with a subtle top border/shadow
    <footer className="bg-gray-50 border-t border-gray-100 shadow-inner">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16"> 
        {/* max-w-7xl centers the content for professional readability */}

        {/* Top Section */}
        {/* Adjusted grid for better responsiveness: 1 column on mobile, 3 on tablet, 7 on desktop */}
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-7 gap-10">

          {/* BRANDING (Takes up 1 column on tablet, 2 on desktop) */}
          <div className="md:col-span-1 lg:col-span-2 space-y-6">
            <Link to="/" className="flex items-center gap-3">
              {/* Refined Icon/Logo styling */}
  <NavLink
            to="/"
            className="flex items-center shrink-0 transform hover:scale-[1.02] transition duration-200"
          >
            <img
              src={logo}
              alt="TalkyToon Logo"
              // Logo size increased back to a very large size.
              // Added NEGATIVE MARGIN (my-[-0.5rem]) to pull the image into the py-0 space, making it look flush and large without increasing the bar's height.
              className="h-16 md:h-24 w-auto object-contain transition-transform hover:scale-105 my-[-0.5rem]"
            />
          </NavLink>



              {/* <span className={`text-2xl font-black ${BRAND_COLOR} tracking-tighter`}>TalkyToon</span> */}
            </Link>

            <p className="text-gray-600 text-base max-w-xs leading-normal">
              Fun-first learning for kids aged 3–8. Games, stories, music, and creativity — all in one safe place.
            </p>

            {/* SOCIAL */}
            <div className="flex gap-5 pt-3">
              {/* <Link to="#" aria-label="Facebook" className="text-gray-400 hover:text-blue-600 transition-colors"><Facebook className="w-6 h-6" /></Link> */}
              {/* <Link to="#" aria-label="Twitter" className="text-gray-400 hover:text-sky-500 transition-colors"><Twitter className="w-6 h-6" /></Link> */}
<a
  href="https://www.instagram.com/talkytoonofficial"
  target="_blank"
  rel="noopener noreferrer"
  aria-label="Instagram"
  className="text-gray-400 hover:text-pink-600 transition-colors"
>
  <Instagram className="w-6 h-6" />
</a>

<a
  href="https://www.youtube.com/@TalkyToonOfficial"
  target="_blank"
  rel="noopener noreferrer"
  aria-label="YouTube"
  className="text-gray-400 hover:text-red-600 transition-colors"
>
  <Youtube className="w-6 h-6" />
</a>

<a
  href="mailto:support@talkytoonofficial@gmail.com"
  aria-label="Email"
  className="text-gray-400 hover:text-green-600 transition-colors"
>
  <Mail className="w-6 h-6" />
</a>

            </div>
          </div>

          {/* NAV SECTIONS */}
          {FOOTER_SECTIONS.map((section) => (
            // Adjusted column span for link sections on tablet/desktop
            <div key={section.title} className="md:col-span-1 lg:col-span-1">
              <h3 className="text-base font-extrabold text-gray-800 uppercase tracking-widest mb-5">
                {section.title}
              </h3>
              <ul className="space-y-4">
                {section.links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      className={`text-gray-600 ${HOVER_COLOR} text-sm transition-colors block`}
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* BOTTOM BAR */}
        <div className="mt-20 pt-8 border-t border-gray-200 flex flex-col md:flex-row items-center justify-between gap-6">
          <p className="text-sm text-gray-500">© {new Date().getFullYear()} TalkyToon, Inc. All rights reserved.</p>
          <div className="flex flex-wrap justify-center gap-x-8 gap-y-2 text-sm">
            <Link to="/privacy" className={`text-gray-600 ${HOVER_COLOR} font-medium`}>Privacy Policy</Link>
            <Link to="/terms" className={`text-gray-600 ${HOVER_COLOR} font-medium`}>Terms of Use</Link>
            {/* <Link to="/refund" className={`text-gray-600 ${HOVER_COLOR} font-medium`}>Refund Policy</Link>
            <Link to="/sitemap" className={`text-gray-600 ${HOVER_COLOR} font-medium`}>Sitemap</Link> */}
          </div>
        </div>
      </div>
    </footer>
  );
}